module.exports = __webpack_public_path__ + "static/media/boston-scientific.544f1cd7.svg";